
































































import Vue from "vue";
import { $eventsBus } from "@/main";
import BaseSimpleSlider from "@/app/shared/components/base/BaseSimpleSlider.vue";
import BaseVideoRangeSlider from "@/app/shared/components/base/BaseVideoRangeSlider.vue";
import BaseCheckbox from "@/app/shared/components/base/BaseCheckbox.vue";
import BaseInput from "@/app/shared/components/base/BaseInput.vue";
import draggable from "vuedraggable";

export default Vue.extend({
  name: "PartsController",
  components: {
    BaseSimpleSlider,
    BaseVideoRangeSlider,
    BaseCheckbox,
    BaseInput,
    draggable,
  },
  data: function () {
    return {};
  },
  computed: {
    items: function () {
      return this.$store.state.items;
    },
    previewItem: function () {
      return this.$store.state.selectedItem;
    },
    allParts: function () {
      return this.$store.state.items.reduce(
        (acc, val) => acc.concat(val.parts),
        []
      );
    },
    mixedParts: {
      get: function () {
        return this.$store.state.mixedParts;
      },
      set: function (mixedParts) {
        this.$store.commit("mixedParts", mixedParts);
      },
    },
    selectedPart: {
      get: function () {
        return this.$store.state.selectedPart;
      },
      set: function (part) {
        this.$store.commit("changeSelectedPart", part);
      },
    },
    isMixerStep: {
      get: function () {
        return this.$store.state.isMixerStep;
      },
      set: function (isMixerStep) {
        this.$store.commit("isMixerStep", isMixerStep);
      },
    },
    dragOptions() {
      return {
        animation: 200,
        group: "parts",
        disabled: false,
        ghostClass: "ghost",
        dragClass: "ghost",
      };
    },
  },
  watch: {},
  mounted() {},
  methods: {
    getPartItem(part) {
      return this.items.find((i) => i.id === part.parentItemInfo.id);
    },
    onDeletePart(part) {
      let item = this.getPartItem(part);
      item.parts.splice(item.parts.indexOf(part), 1);
      while (this.mixedParts.indexOf(part) !== -1) {
        this.mixedParts.splice(this.mixedParts.indexOf(part), 1);
      }
      if (this.isMixerStep && this.mixedParts.length === 0) {
        this.isMixerStep = false;
        $eventsBus.$emit("setVideoPaused", true);
        $eventsBus.$emit("setContentTime", 0);
      }
      if (part === this.selectedPart) {
        this.selectedPart = null;
        if (this.isMixerStep) {
          this.selectedPart = this.mixedParts[0];
        }
      }
    },
    onEditPart(part) {
      if (this.isMixerStep) {
        this.isMixerStep = false;
        $eventsBus.$emit("setVideoPaused", true);
        $eventsBus.$emit("setContentTime", 0);
      }
      this.selectedPart = part;
    },
    getPartFirstThumb(part) {
      let item = this.getPartItem(part);
      let thumbs =
        item.thumbs.length === 0
          ? item.loadingParameters.localThumbs
          : item.thumbs;
      let startIndex = Math.ceil(
        (part.startTime * thumbs.length) / item.duration
      );

      if (startIndex < 0) {
        startIndex = 0;
      } else if (startIndex > thumbs.length - 1) {
        startIndex = thumbs.length - 1;
      }
      let thumb = thumbs[startIndex];
      return (item.thumbs.length === 0 ? "" : this.$baseURL) + thumb;
    },
  },
});
